import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './pedidoForm';
import FormatUtils from '../common/formatUtils/FormatUtils';
import Aguardando from '../common/template/aguardando';

import { 
	setModoTela, initForm, setFiltro, salvar, excluir, getListaFinalizado as getLista, setFormPedido,
	getListaDistribuidora, getListaPoliticaPreco, getListaUnidade, getListaMotorista, 
	getListaVeiculo, getListaCliente, getListaEndereco, getListaProduto, getListaCustoPrazo, gerarOrcamento,
	verificaEstoqueManual, verificaAbastecida,
	getListaPedidoTipo, getListaPedidoFrete, getListaPedidoCnpj
} from './pedidoActions';
import { getLista as getListaPedidoPrazo } from '../pedidoPrazo/pedidoPrazoActions';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import PedidoBaseVisualizacao from './pedidoBaseVisualizacao';
import PedidoOcorrencia from '../pedidoOcorrencia/pedidoOcorrencia';
import Select from '../common/form/select';

class PedidoFinalizado extends Component {

	state = {
		linhaSelecionada: null
	}

    componentWillMount() {
		this.props.setModoTela('lista');
		this.props.getLista(this.props.filtro.data_inicial, this.props.filtro.data_final);
		this.props.getListaDistribuidora();
		this.props.getListaPoliticaPreco();
		this.props.getListaUnidade();
		this.props.getListaMotorista();
		this.props.getListaVeiculo();
		this.props.getListaCliente();
		this.props.getListaEndereco();
		this.props.getListaProduto();
		this.props.getListaCustoPrazo();
		this.props.verificaEstoqueManual();
		this.props.verificaAbastecida();
		this.props.getListaPedidoTipo();
		this.props.getListaPedidoFrete();
		this.props.getListaPedidoCnpj();
		this.props.getListaPedidoPrazo();

		let idInterval = setInterval(() => {
			if (this.props.modoTela == 'lista') {
				this.props.getLista(this.props.filtro.data_inicial, this.props.filtro.data_final);
			}
			this.props.getListaDistribuidora();
			this.props.getListaPoliticaPreco();
			this.props.getListaUnidade();
			this.props.getListaMotorista();
			this.props.getListaVeiculo();
			this.props.getListaCliente();
			this.props.getListaEndereco();
			this.props.getListaProduto();
			this.props.getListaCustoPrazo();
			this.props.verificaEstoqueManual();
			this.props.verificaAbastecida();
			this.props.getListaPedidoPrazo();
		}, 60000);
		
		this.setState({
			...this.state,
			idInterval: idInterval
		});
	}
	
	componentWillUnmount() {

		if (this.state.idInterval) {
			clearInterval(this.state.idInterval);
		}
	
    }

    render() {

		if (!this.props.estoqueManualLancado) {
			return (
				<div>
					<Content>
						
						<Row>
							<Grid cols='12 12 12 12'>
								<div class="alert alert-danger alert-dismissible">
									<h5><i class="icon fas fa-ban"></i> Operação Bloqueada!</h5>
									<h6>Lance o estoque físico de todas as bases para desbloquear.</h6>
									<h6>Ou lance uma ocorrência do tipo (BASE NÃO REALIZOU LANÇAMENTOS DIÁRIOS).</h6>
								</div>
							</Grid>
						</Row>
					</Content>
				</div>
			);
		}
		if (!this.props.abastecidaLancada) {
			return (
				<div>
					<Content>
						
						<Row>
							<Grid cols='12 12 12 12'>
								<div class="alert alert-danger alert-dismissible">
									<h5><i class="icon fas fa-ban"></i> Operação Bloqueada!</h5>
									<h6>Lance as abastecidas de todas as bases para desbloquear.</h6>
									<h6>Ou lance uma ocorrência do tipo (BASE NÃO REALIZOU LANÇAMENTOS DIÁRIOS).</h6>
								</div>
							</Grid>
						</Row>
					</Content>
				</div>
			);
		}	

		const lista = this.filtrar();

        return (
            <div>
                <Content>
					
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.listaVeiculo.filter(item => item.documentacao_vencida).length > 0 && 
					<Row alignCenter>
						{this.props.listaVeiculo.filter(item => 
							item.documentacao_vencida
							&& lista.filter(pedido => pedido.id_veiculo == item.id).length
						).map(item => (
							<div key={item.id}
								style={{
									backgroundColor: '#de0000',
									color: '#ffffff', 
									margin: 4,
									paddingLeft: 12,
									paddingTop: 4,
									paddingRight: 12,
									paddingBottom: 4,
									borderRadius: 4,
									textAlign: 'center'
								}}>
								<div>
									<i class="icon fas fa-ban"></i> Problemas na documentação!
								</div>
								<div style={{ fontWeight: 'bold' }}>
									{item.valor}
								</div>
							</div>
						))}
					</Row>}

					{this.props.modoTela == 'visualizacao' ? (
						<Form onSubmit={this.props.salvar} visualizacao />
					) : null}
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} visualizacao />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	filtrar() {
		return this.props.lista.filter(item => {
			if (this.state.pesquisar
				&& !(`${DateFormat.formatarDataSqlParaTela(item.data_pedido)} ${item.nome_status} ${item.clientes}
										${item.giro} ${item.nome_motorista} ${item.placa_veiculo} ${item.nome_usuario_inclusao}
									`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
				return false;
			}
			return true;
		}).filter(item => 
			item.id_status == 3 || item.id_status == 7
		).filter(item =>
			item.id_usuario_inclusao == (this.props.sessao ? this.props.sessao.id : 0)
			|| (this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_pedido_aprovacao)
			|| (this.props.usuarioCarregado && this.props.usuarioCarregado.id_perfil == 27) //Manutenção + Frota + Base
		).filter(item => {
			if (this.props.usuarioCarregado && [30, 31, 32].includes(this.props.usuarioCarregado.id_perfil)
				&& this.props.usuarioCarregado.ids_gestao_unidade[0]
				&& this.props.usuarioCarregado.ids_gestao_unidade[0] != item.id_unidade) {
				return false
			}
			return true;
		}).filter(item => {
			if ((this.props.filtro.ids_unidades || []).length && !(this.props.filtro.ids_unidades || []).includes(item.id_unidade)) {
				return false;
			}
			if ((this.props.filtro.ids_clientes || []).length && !(item.itens || []).filter(cli => cli && (this.props.filtro.ids_clientes || []).includes(cli.id_cliente)).length) {
				return false;
			}
			if ((this.props.filtro.ids_motoristas || []).length && !(this.props.filtro.ids_motoristas || []).includes(item.id_motorista)) {
				return false;
			}
			if ((this.props.filtro.ids_veiculos || []).length && !(this.props.filtro.ids_veiculos || []).includes(item.id_veiculo)) {
				return false;
			}

			return true;
		});
	}

	lista() {

		const lista = this.filtrar();

		let capacidadeTotalCalculoOcioso = 0;
		let quantidadeOciosa = 0;

		return (
			<ContentCard>
				
				{this.modalBaseVisualizacao()}

				{this.modalOcorrencia()}

				<ContentCardHeader>
					<Row>
						<LabelAndInputMask
							name='data_inicial'
							label='Data Inicial' placeholder='Informe a data'
							cols='12 6 2 2'
							mask='99/99/9999'
							maxWidth={130}
							value={this.props.filtro.data_inicial}
							onChange={data => {
								this.props.setFiltro({ ...this.props.filtro, data_inicial: data.target.value });
							}} />

						<LabelAndInputMask
							name='data_final'
							label='Data Final' placeholder='Informe a data'
							cols='12 6 2 2'
							mask='99/99/9999'
							maxWidth={130}
							value={this.props.filtro.data_final}
							onChange={data => {
								this.props.setFiltro({ ...this.props.filtro, data_final: data.target.value });
							}} />

						<Select
							options={this.props.listaUnidade}
							label='Unidade'
							cols='12 6 3 3'
							placeholder='Selecione'
							maxWidth={220}
							multiple
							value={this.props.listaUnidade.filter(item => (this.props.filtro.ids_unidades || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.props.setFiltro({ ...this.props.filtro, ids_unidades: (values || []).map(item => item.value) });
							}} />

						<Select
							options={this.props.listaCliente}
							label='Cliente'
							cols='12 6 3 3'
							maxWidth={300}
							placeholder='Selecione'
							multiple
							value={this.props.listaCliente.filter(item => (this.props.filtro.ids_clientes || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.props.setFiltro({ ...this.props.filtro, ids_clientes: (values || []).map(item => item.value) });
							}} />

						<Select
							options={this.props.listaMotorista}
							label='Motorista'
							cols='12 6 3 3'
							placeholder='Selecione'
							maxWidth={220}
							multiple
							value={this.props.listaMotorista.filter(item => (this.props.filtro.ids_motoristas || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.props.setFiltro({ ...this.props.filtro, ids_motoristas: (values || []).map(item => item.value) });
							}} />

						<Select
							options={this.props.listaVeiculo}
							label='Veículo'
							cols='12 6 3 3'
							maxWidth={220}
							placeholder='Selecione'
							multiple
							value={this.props.listaVeiculo.filter(item => (this.props.filtro.ids_veiculos || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.props.setFiltro({ ...this.props.filtro, ids_veiculos: (values || []).map(item => item.value) });
							}} />

						<Grid cols='6 6 4 2' style={{ paddingTop: 28, maxWidth: 140 }}>
							<Button
								text='Atualizar'
								type={'primary'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.getLista(this.props.filtro.data_inicial, this.props.filtro.data_final);
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>

				<ContentCardBody>
					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />
					<Table responsive>
						<THead>
							<Tr>
								<Th>Data</Th>
								<Th alignCenter>Status</Th>
								<Th alignCenter>Giro</Th>
								<Th alignCenter>Motorista</Th>
								<Th alignCenter>Placa</Th>
								<Th alignCenter>Vendedor</Th>
								<Th alignCenter>Aprovação</Th>
								<Th alignCenter>Logística</Th>
								<Th alignCenter>Entrega</Th>
								<Th alignCenter>Clientes</Th>
								<Th alignCenter>Meta/Realizado</Th>
								<Th alignCenter>Volume Ocioso</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map(item => {

								capacidadeTotalCalculoOcioso += parseFloat(item.capacidade_total_calculo_ocioso || 0);
								quantidadeOciosa += parseFloat(item.quantidade_ociosa || 0);

								return (
									<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
										onClick={() => this.setState({ linhaSelecionada: item.id })}
										onMouseEnter={() => this.setState({ linhaSelecionada: item.id })}
										style={{ backgroundColor: item.id_status == 3 ? '#ff426e' : '#dffa14' }} >
										<Td>{DateFormat.formatarDataSqlParaTela(item.data_pedido)}</Td>
										<Td alignCenter>{item.venda_perdida ? 'Venda Perdida' : item.nome_status}</Td>
										<Td alignCenter>{item.giro}</Td>
										<Td alignCenter>{item.nome_motorista}</Td>
										<Td alignCenter>{item.placa_veiculo}</Td>
										<Td alignCenter>{item.nome_usuario_inclusao}</Td>
										<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_aprovacao_rejeicao)}</Td>
										<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_logistica)}</Td>
										<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_entrega)}</Td>
										<Td alignCenter>{item.clientes}</Td>
										<Td alignCenter>{parseInt(item.tempo_carregamento_meta)}/{parseInt(item.tempo_carregamento_realizado)}</Td>
										<Td alignCenter>
											<div>
												{FormatUtils.formatarValorTelaDecimal(item.quantidade_ociosa, 0)} L
											</div>
											<div 
												style={{
													backgroundColor: parseFloat(item.percentual_ocioso) > 0.00 ? '#ff0000' : '#3c57cf',
													color: '#ffffff',
													fontSize: 12,
													width: 60,
													paddingLeft: 2,
													paddingRight: 2,
													paddingTop: 1,
													paddingBottom: 1,
													borderRadius: 20
												}}>
												{FormatUtils.formatarValorTelaDecimal(item.percentual_ocioso, 2)}%
											</div>
										</Td>
										<Td alignRight minWidth={150}>
											<ButtonTable
												type={item.possui_ocorrencia ? 'danger' : 'secondary'}
												icon={'fas fa-exclamation-circle'}
												visible={this.state.linhaSelecionada == item.id}
												event={() => {
													this.setState({
														...this.state,
														modalOcorrencia: {
															...item
														}
													})
												}} />

											<ButtonTable
												type={'primary'}
												icon={'fas fa-gas-pump'}
												visible={this.state.linhaSelecionada == item.id}
												event={() => {
													this.setState({
														...this.state,
														modalBaseVisualizacao: {
															...item
														}
													})
												}} />

											{(this.props.usuarioCarregado && this.props.usuarioCarregado.id_perfil != 27) && //Manutenção + Frota + Base
											<ButtonTable
												type={'primary'}
												icon={'fas fa-eye'}
												visible={this.state.linhaSelecionada == item.id}
												event={() => {

													this.props.setFormPedido('pedidoFinalizado', 'visualizacao', item);

													// this.props.setModoTela('visualizacao', {
													// 	...item,
													// 	itens: (item.itens || []).map(pedidoItem => ({
													// 		...pedidoItem,
													// 		quantidade: FormatUtils.formatarValorTela(pedidoItem.quantidade, 2),
													// 		preco_unitario_bruto: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_bruto, 4),
													// 		preco_unitario_base: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_base, 4),
													// 		preco_unitario_frete: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_frete, 4),
													// 		preco_unitario: FormatUtils.formatarValorTela(pedidoItem.preco_unitario, 4),
													// 		preco_prazo: FormatUtils.formatarValorTela(pedidoItem.preco_prazo, 4),
													// 		valor_total: FormatUtils.formatarValorTela(pedidoItem.valor_total, 2),
													// 		data_emissao_nfe: DateFormat.formatarDataSqlParaTela(pedidoItem.data_emissao_nfe),
													// 		datahora_previsao_entrega: DateFormat.formatarDataHoraSqlParaTela(pedidoItem.datahora_previsao_entrega)
													// 	}))
													// });
													
													// this.props.initForm({
													// 	...item,
													// 	itens: (item.itens || []).map(pedidoItem => ({
													// 		...pedidoItem,
													// 		quantidade: FormatUtils.formatarValorTela(pedidoItem.quantidade, 2),
													// 		preco_unitario_bruto: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_bruto, 4),
													// 		preco_unitario_base: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_base, 4),
													// 		preco_unitario_frete: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_frete, 4),
													// 		preco_unitario: FormatUtils.formatarValorTela(pedidoItem.preco_unitario, 4),
													// 		preco_prazo: FormatUtils.formatarValorTela(pedidoItem.preco_prazo, 4),
													// 		valor_total: FormatUtils.formatarValorTela(pedidoItem.valor_total, 2),
													// 		data_emissao_nfe: DateFormat.formatarDataSqlParaTela(pedidoItem.data_emissao_nfe),
													// 		datahora_previsao_entrega: DateFormat.formatarDataHoraSqlParaTela(pedidoItem.datahora_previsao_entrega)
													// 	}))
													// });
												}} />}

											{(this.props.usuarioCarregado && this.props.usuarioCarregado.id_perfil != 27) && //Manutenção + Frota + Base
											<ButtonTable
												type={'primary'}
												icon={'fas fa-download'}
												visible={this.state.linhaSelecionada == item.id}
												event={() => {
													this.props.gerarOrcamento(item);
												}} />}

											{(this.props.usuarioCarregado && this.props.usuarioCarregado.id_perfil != 27) && //Manutenção + Frota + Base
											<ButtonTable
												type={'success'}
												icon={'fab fa-whatsapp'}
												visible={this.state.linhaSelecionada == item.id}
												
												title={item.celular_motorista ? 'Mensagem para motorista' : 'Sem motorista ou motorista sem celular configurado'}
												event={() => {

													let mensagem = `*Giro**:* *${item.giro}*\n`;
													mensagem += `Placa: ${item.placa_veiculo}\n`;
													mensagem += `Entregas:\n`;
													(item.itens || []).forEach((pedidoItem, i) => {													
														mensagem += `  *Pedido* *${i + 1}**:*\n`;
														mensagem += `  Cliente: ${pedidoItem.nome_cliente}\n`;
														mensagem += `  Endereço: ${pedidoItem.nome_endereco}\n`;
														mensagem += `  Produto: ${pedidoItem.nome_produto}\n`;
														mensagem += `  Quantidade: ${FormatUtils.formatarValorTela(pedidoItem.quantidade, 2)}\n`;
														mensagem += `  Obs: ${pedidoItem.observacao}\n\n`;
													});
													if (item.rota_link) {
														mensagem += `Link: ${item.rota_link}`;
													}
													window.open(`https://api.whatsapp.com/send?phone=+55${item.celular_motorista}&text=${encodeURI(mensagem)}`, '_blank');
											
												}} />}
										</Td>
									</Tr>
								)
							})}

							<Tr>
								<Td></Td>
								<Td alignCenter></Td>
								<Td alignCenter></Td>
								<Td alignCenter></Td>
								<Td alignCenter></Td>
								<Td alignCenter></Td>
								<Td alignCenter></Td>
								<Td alignCenter></Td>
								<Td alignRight colspan={3} bold>Capacidade Total:</Td>
								<Td alignCenter bold>{FormatUtils.formatarValorTelaDecimal(capacidadeTotalCalculoOcioso, 0)}L</Td>
								<Td alignRight minWidth={150}>
								</Td>
							</Tr>
							<Tr>
								<Td></Td>
								<Td alignCenter></Td>
								<Td alignCenter></Td>
								<Td alignCenter></Td>
								<Td alignCenter></Td>
								<Td alignCenter></Td>
								<Td alignCenter></Td>
								<Td alignCenter></Td>
								<Td alignRight colspan={3} bold>Volume Ocioso:</Td>
								<Td alignCenter bold>{FormatUtils.formatarValorTelaDecimal(quantidadeOciosa, 0)}L</Td>
								<Td alignRight minWidth={150}>
								</Td>
							</Tr>
							<Tr>
								<Td></Td>
								<Td alignCenter></Td>
								<Td alignCenter></Td>
								<Td alignCenter></Td>
								<Td alignCenter></Td>
								<Td alignCenter></Td>
								<Td alignCenter></Td>
								<Td alignCenter></Td>
								<Td alignRight colspan={3} bold>Percentual Ocioso:</Td>
								<Td alignCenter bold>{
									FormatUtils.formatarValorTelaDecimal(
										quantidadeOciosa > 0 && capacidadeTotalCalculoOcioso > 0 ? ((quantidadeOciosa * 100) / capacidadeTotalCalculoOcioso) : 0
									, 2)
								}%</Td>
								<Td alignRight minWidth={150}>
								</Td>
							</Tr>
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

	modalBaseVisualizacao() {

		if (!this.state.modalBaseVisualizacao) {
			return null;
		}
		
		const registro = { ...this.state.modalBaseVisualizacao };

        return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl'>
					<div class='modal-content'>
						<div class='modal-header'>
							<h4 class='modal-title'>Processo de Carregamento na Base</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setState({ ...this.state, modalBaseVisualizacao: null, zoom: 100 })}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ maxHeight: window.innerHeight - 200, overflowY: 'scroll' }}>

							<PedidoBaseVisualizacao registro={registro} 
								eventoAtualizacao={() => {
									this.props.getLista(this.props.filtro.data_inicial, this.props.filtro.data_final);
									this.setState({ ...this.state, modalBaseVisualizacao: null, zoom: 100 });
								}} />
								
						</div>
						<div class=''>
							<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
						</div>
					</div>
				</div>
			</div>
        );
    }

	modalOcorrencia() {

		if (!this.state.modalOcorrencia) {
			return null;
		}
		
		const registro = { ...this.state.modalOcorrencia };

        return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl'>
					<div class='modal-content'>
						<div class='modal-header'>
							<h4 class='modal-title'>Ocorrências - {registro.giro}</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setState({ ...this.state, modalOcorrencia: null, zoom: 100 })}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ maxHeight: window.innerHeight - 200, overflowY: 'scroll' }}>
							<PedidoOcorrencia idPedido={registro.id} pedidoItens={registro.itens || []} 
								eventoAtualizacao={() => {
									this.props.getLista(this.props.filtro.data_inicial, this.props.filtro.data_final);
									this.setState({ ...this.state, modalOcorrencia: null, zoom: 100 });
								}} />
								
						</div>
						<div class=''>
							<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
						</div>
					</div>
				</div>
			</div>
        );
    }

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.pedido.aguardando,
	modoTela: state.pedido.modoTela,
	filtro: state.pedido.filtro,
	lista: state.pedido.listaFinalizado,
    listaVeiculo: state.pedido.listaVeiculo,
	estoqueManualLancado: state.pedido.estoqueManualLancado,
	abastecidaLancada: state.pedido.abastecidaLancada,
	listaUnidade: state.pedido.listaUnidade,
	listaCliente: state.pedido.listaCliente,
	listaMotorista: state.pedido.listaMotorista,
	listaVeiculo: state.pedido.listaVeiculo
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, setFiltro, salvar, excluir, getLista, setFormPedido,
	getListaDistribuidora, getListaPoliticaPreco, getListaUnidade, getListaMotorista, 
	getListaVeiculo, getListaCliente, getListaEndereco, getListaProduto, getListaCustoPrazo, gerarOrcamento,
	verificaEstoqueManual, verificaAbastecida,
	getListaPedidoTipo, getListaPedidoFrete, getListaPedidoCnpj, getListaPedidoPrazo
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(PedidoFinalizado);
